module.exports = __webpack_public_path__ + "static/img/female-bg-tr.482716f9.png";